import { render, staticRenderFns } from "./bodega-noemia-patagonia.vue?vue&type=template&id=39d6b040&scoped=true"
import script from "./bodega-noemia-patagonia.vue?vue&type=script&lang=js"
export * from "./bodega-noemia-patagonia.vue?vue&type=script&lang=js"
import style0 from "./bodega-noemia-patagonia.vue?vue&type=style&index=0&id=39d6b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6b040",
  null
  
)

export default component.exports